import { render, staticRenderFns } from "./block-undermain.vue?vue&type=template&id=4d9da8f2&scoped=true"
import script from "./block-undermain.vue?vue&type=script&lang=js"
export * from "./block-undermain.vue?vue&type=script&lang=js"
import style0 from "./block-undermain.vue?vue&type=style&index=0&id=4d9da8f2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d9da8f2",
  null
  
)

export default component.exports